<script setup lang="ts">
defineProps<{
  title: string;
  content: string;
  label: string;
  to: string;
}>();
</script>

<template>
  <section class="rounded-2xl bg-slate-900 p-6 text-white sm:p-10">
    <h2 class="text-2xl font-bold sm:text-3xl">
      {{ title }}
    </h2>
    <p class="mt-3 max-w-2xl leading-7 text-slate-200">
      {{ content }}
    </p>
    <NuxtLink
      :to="to"
      class="mt-6 inline-flex min-h-11 items-center rounded-lg bg-brand-600 px-5 py-3 font-semibold text-white transition-colors hover:bg-brand-700 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-300"
    >
      {{ label }}
    </NuxtLink>
  </section>
</template>
